import React, {memo, useState} from 'react'
import _ from 'lodash'
import {Button, Header, List, Modal} from 'semantic-ui-react'
import {withErrorHandling, withHelmet, withInvoicePreviewData, withPropsPresent, withSubscriptionData} from '../../hoc'
import {getAmountString, toLocaleDateString} from '../../util'
import {updatePlan} from '../../backend'

const _ConfirmPlan = (
  {
    plan,
    invoicePreview,
    updatePlan,
    onClose
  }
) => {
  const [state, setState] = useState({submitting: false})

  const close = () => {
    onClose()
  }

  const onConfirm = async (e) => {
    e.preventDefault()
    const {subscription_proration_date} = invoicePreview
    setState({...state, submitting: true})
    const updated = await updatePlan(subscription_proration_date, plan)
    onClose(updated)
  }

  return (
    <Modal open={true} closeOnDimmerClick={true} closeIcon={true} onClose={close} data-testid='confirm-plan-modal'>
      <Header content='Confirm Plan Change'/>
      <Modal.Content>
        <List relaxed>
          <List.Item>
            <List.Content>
              <List.Header>Billing Cycle</List.Header>
              <List.Description>
                {_.startCase(plan)}
              </List.Description>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>Subscription Change(s)</List.Header>
              <List.List>
                {
                  invoicePreview.lines.data.map(line => (
                    <List.Item key={line.id}>
                      <List.Description>
                        - {line.description} = {getAmountString(line.amount)}
                      </List.Description>
                    </List.Item>
                  ))
                }
              </List.List>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>Adjustment Scheduled For:</List.Header>
              <List.Description>
                {toLocaleDateString(new Date(invoicePreview.next_payment_attempt * 1000))}
              </List.Description>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>Sub Total</List.Header>
              <List.Description>
                {getAmountString(invoicePreview.subtotal)}
              </List.Description>
            </List.Content>
          </List.Item>ßß
        </List>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close} data-testid='confirm-plan-cancel-button'>Cancel</Button>
        <Button primary loading={state.submitting} onClick={onConfirm} data-testid='confirm-plan-submit-button'>Confirm</Button>
      </Modal.Actions>
    </Modal>
  )
}

let ConfirmPlan = (props) => {
  const {handleError} = props
  if (props.plan === props.subscription.planName) {
    return null
  }
  props = {...props, updatePlan: handleError(updatePlan)}
  return (<_ConfirmPlan {...props}/>)
}

ConfirmPlan = withHelmet(ConfirmPlan, 'Confirm Plan')
ConfirmPlan = withPropsPresent(ConfirmPlan, ['plan', 'invoicePreview'])
ConfirmPlan = withInvoicePreviewData(ConfirmPlan, '', false)
ConfirmPlan = withErrorHandling(ConfirmPlan)
ConfirmPlan = memo(ConfirmPlan)

export {_ConfirmPlan, ConfirmPlan}

export default ConfirmPlan